<ng-container *ngIf="initialized">
  <ua-header></ua-header>
  <div class="app-content container">
    <router-outlet></router-outlet>
  </div>
  <ua-salesforce-chat></ua-salesforce-chat>
  <ua-footer></ua-footer>
</ng-container>
<ua-spinner></ua-spinner>
